import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the DEX Blockchains API.
 *
 * This file drives:
 * - Enhanced API: computed endpoint keys in `enhanceEndpoints`
 * - Hook re-exports: clean name → generated name mapping
 * - MSW mock factories: HTTP method + URL path pattern
 */
export const DEX_BLOCKCHAINS_API_ENDPOINTS = {
  listBlockchains: {
    generated: 'apiControllerGetBlockchains',
    method: 'get',
    path: '/web/blockchains',
  },
  getBlockchain: {
    generated: 'apiControllerGetBlockchain',
    method: 'get',
    path: '/web/blockchains/:blockchainId',
  },
  createBlockchain: {
    generated: 'apiControllerCreateBlockchain',
    method: 'post',
    path: '/web/blockchains',
  },
  updateBlockchain: {
    generated: 'apiControllerUpdateBlockchain',
    method: 'put',
    path: '/web/blockchains/:blockchainId',
  },
  deleteBlockchain: {
    generated: 'apiControllerDeleteBlockchain',
    method: 'delete',
    path: '/web/blockchains/:blockchainId',
  },
  changeBlockchainNode: {
    generated: 'apiControllerChangeNode',
    method: 'put',
    path: '/web/change_node/:blockchainId',
  },
  switchBlockchainPrivateRPC: {
    generated: 'apiControllerSwitchPrivate',
    method: 'put',
    path: '/web/switch_private/:blockchainId',
  },
  reloadApp: {
    generated: 'apiControllerReloadApp',
    method: 'post',
    path: '/web/reload',
  },
} as const satisfies Record<string, EndpointDef>;

export type DexBlockchainsEndpointName = keyof typeof DEX_BLOCKCHAINS_API_ENDPOINTS;
